import colors from '~lib/src/themes/common/proxy/colors.scss';

export default (ctx, inject) => {
  inject('theme', {
    colors,
  });
};
